import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import "../../agent/Styles/darktheme.css";
import "../../agent/Styles/blacktheme.css";
import "../../agent/Styles/highContrast.css";
import { setAgentConfigData, get_themevalue, setAgentConfig } from '../../actions/getAgentConfig';
import { set_theme, get_theme, set_themecode} from "../../actions/common";
import classnames from 'classnames';
import getV2AxiosInstance from '../../utils/v2Axios.js';


class ThemeModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
            showThemeModal:props.showThemeModal,
            // themevalue: "",
            // themecode: ""
		};
    }

  close = (key) => {
    this.setState({
      showErr: false
    }, () => {
      this.props.handleClose(key);
    });
  }

  handleOnThemeNotUpdated = () => {
    this.setState({
      showErr: true,
      errorMsg:
        this.props.translations.commonErrorText[this.props.selectedLanguage],
    });
  }

  handleSubmit = () => {
    const username = localStorage.getItem("username");
    const agent_id = localStorage.getItem("agent_id");
    const client_id = localStorage.getItem("clientId");

    getV2AxiosInstance()
      .patch(`/api/es/invoxapi/userproperties/${username}`, {
        data: {
          apps: {
            webagent: {
              theme: this.state.themecode,
            },
          },
        },
      })
      .then((res) => {
        if (res.data.result) {

          // console.log(window.listener);
          
        
            //window.mq.debug(true)
           window.mq.send(`/exchange/signal.${client_id}/user.${agent_id}`, {}, `{"tag":"theme_change","data" : "${this.state.themecode}"}`);
      //console.log(`"/exchange/signal.${client_id}/user.${agent_id}", {}, '{"tag":"topic"}'`)


         
          let { agentConfig } = this.props;
          agentConfig.preference.themetype = this.state.themecode;
          this.props.handleClose(this.props.showThemeModal);
          this.props.setAgentConfig(JSON.parse(JSON.stringify(agentConfig)));
        } else {
          this.handleOnThemeNotUpdated();
        }
      })
      .catch(this.handleOnThemeNotUpdated);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      themevalue: nextProps.gettheme,
      themecode: nextProps.themecode
    });

    if(nextProps.themecode === ""){
      this.props.set_theme("");
      this.props.get_theme(this.props.translations.light[this.props.selectedLanguage]); 
      this.props.set_themecode("default"); 
    }
  }
  changeTheme = (item) => {
    this.setState({
      themevalue: item.name,
      themecode: item.code
    });
  }
  
  render(){
    const { translations, selectedLanguage } = this.props;
    const giventhemes = [
      { name: translations.light[selectedLanguage], code: "default" },
      { name: translations.darkblue[selectedLanguage], code: "darkblue" },
      { name: translations.dark[selectedLanguage], code: "dark" },
      { name: translations.highContrast[selectedLanguage], code: "highContrast" }
    ];
    return (
      <Modal
        show={this.props.showThemeModal}
        onEnter={this.handleEnter}
        onHide={() => this.close('showThemeModal')}
        bsSize="sm"
        backdrop="static">
        <Modal.Header className={`modal-content${this.props.theme} modal-header${this.props.theme}`} closeButton>
          <Modal.Title>{translations.theme[selectedLanguage]}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={`modal-content${this.props.theme}`}>
        {/* <select value={this.props.gettheme} onChange={this.handleAllSelect} className="form-control custom-select" style={{width: "200px"}}>
        <option className={`selectoptions${this.props.theme}`}>Light</option>
        <option className={`selectoptions${this.props.theme}`}>Dark Blue</option>
        <option className={`selectoptions${this.props.theme}`}>Dark</option>      
        </select> */}

          <div className="list-group">
            {giventhemes.map(item => (
              <button
                key={item.code}
                type="button"
                onClick={() => this.changeTheme(item)}
                className={classnames(`list-group-item list-group-item${this.props.theme}`, {active: this.state.themecode == item.code })}>
                <span>{item.name}</span>
              </button>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer className={`modal-content${this.props.theme}`}>
        <button type="button" onClick={() => this.close('showThemeModal')} className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`} data-dismiss="modal">{translations.cancel[selectedLanguage]}</button>
        <button type="submit" onClick={this.handleSubmit} className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`} data-dismiss="modal">
            <strong>{translations.save[selectedLanguage]}</strong>
          </button> 
        </Modal.Footer>
      </Modal>
    )
  }
}

function mapStateToProps  (state) {
    return {
        agentInfo: state.agentInfo,
        translations: state.languages.translations,
        selectedLanguage: state.languages.selectedLanguage,
        darkMode: state.common.darkMode,
        theme: state.common.theme,
        gettheme: state.common.gettheme,
        themecode: state.common.themecode,
        getthemevalue: state.common.getthemevalue,
        agentConfig: state.agentConfig,
    };
}

function mapDispatchToProps (dispatch) {
    return bindActionCreators({ setAgentConfigData, setAgentConfig, set_theme, get_theme, set_themecode, get_themevalue}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeModal);



// WEBPACK FOOTER //
// ./src/agent/modals/ThemeModal.js